import React from "react";
import classNames from "classnames";
import styles from "./SidebarFeedbackModal.module.css";

type FeedbackTypeOption = {
  id: number;
  text: string;
  value: string;
};

type SidebarFeedbackTypeDropdownProps = {
  label: string;
  placeholder: string;
  feedbackType: string;
  isDropdownOpen: boolean;
  showRequiredError: boolean;
  dropdownRef: React.RefObject<HTMLDivElement>;
  options: FeedbackTypeOption[];
  onToggle: () => void;
  onSelect: (value: string) => void;
  requiredErrorText: string;
};

export default function SidebarFeedbackTypeDropdown({
  label,
  placeholder,
  feedbackType,
  isDropdownOpen,
  showRequiredError,
  dropdownRef,
  options,
  onToggle,
  onSelect,
  requiredErrorText,
}: SidebarFeedbackTypeDropdownProps) {
  const isPlaceholder = !feedbackType;
  const selectedOption = options.find((item) => item.value === feedbackType);
  const triggerLabel = selectedOption?.text ?? (feedbackType || placeholder);
  return (
    <div className={styles.fieldGroup}>
      <label className={styles.fieldLabel}>
        {label}
        <span className={styles.requiredMark}>*</span>
      </label>
      <div className={styles.dropdownWrapper} ref={dropdownRef}>
        <button
          type="button"
          className={classNames(styles.dropdownTrigger, {
            [styles.dropdownTriggerActive]: isDropdownOpen,
            [styles.dropdownError]: showRequiredError,
          })}
          onClick={onToggle}
        >
          <span
            className={classNames(styles.dropdownTriggerText, {
              [styles.dropdownPlaceholderText]: isPlaceholder,
            })}
          >
            {triggerLabel}
          </span>
          <span
            className={classNames(styles.dropdownChevron, {
              [styles.dropdownChevronOpen]: isDropdownOpen,
            })}
          >
            <img src="/images/Down-arrow.svg" alt="" />
          </span>
        </button>

        {isDropdownOpen && (
          <div className={styles.dropdownMenu}>
            {options.map((item) => {
              const isSelected = feedbackType === item.value;
              return (
                <button
                  key={item.id}
                  type="button"
                  className={classNames(styles.dropdownOption, {
                    [styles.dropdownOptionSelected]: isSelected,
                  })}
                  onClick={() => onSelect(isSelected ? "" : item.value)}
                >
                  <span>{item.text}</span>
                  {isSelected && (
                    <span className={styles.selectedCheck}>
                      <img src="/images/Select-check.svg" alt="" />
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
      {showRequiredError && (
        <p className={styles.dropdownErrorText}>{requiredErrorText}</p>
      )}
    </div>
  );
}
